<div class="row page-header">
    <div class="col-12">
        <h1>Fab Setup <small>(Beta) Process steps, jobs, and hold reasons</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    @if (unresolvedJobs.length) {
        <div class="alert alert-warning py-2">
            <div class="d-flex justify-content-between align-items-center">
                <button type="button" class="btn btn-link p-0" (click)="unresolvedExpanded = !unresolvedExpanded">
                    {{ unresolvedJobs.length }} job{{ unresolvedJobs.length === 1 ? '' : 's' }} not resolved to Vista
                    ({{ unresolvedExpanded ? 'hide' : 'show' }})
                </button>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="exportUnresolvedCsv()">Export CSV</button>
            </div>
            @if (unresolvedExpanded) {
                <table class="table table-sm table-striped mb-0 mt-2">
                    <thead>
                        <tr>
                            <th>Schedule ref</th>
                            <th>Name</th>
                            <th>Vista job</th>
                            <th>Internal</th>
                            <th>Pieces</th>
                            <th>Sample DWG #</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of unresolvedJobs; track row.id) {
                            <tr>
                                <td>{{ row.scheduleReference }}</td>
                                <td>{{ row.name }}</td>
                                <td>{{ row.vpJobId }}</td>
                                <td>{{ row.isInternal ? 'Yes' : '' }}</td>
                                <td>{{ row.pieceCount }}</td>
                                <td>{{ row.sampleMarks }}</td>
                                <td>{{ row.reason }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>
    }

    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mb-3" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Process Steps</a>
            <ng-template ngbNavContent>
                <app-fab-process-steps-list
                    [canEdit]="canEdit"
                    [items]="processSteps"
                    (modified)="onChildModified()"
                ></app-fab-process-steps-list>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Jobs</a>
            <ng-template ngbNavContent>
                <app-fab-jobs-list
                    [canEdit]="canEdit"
                    [items]="jobs"
                    [vpJobOptions]="vpJobOptions"
                    (modified)="onChildModified()"
                ></app-fab-jobs-list>
            </ng-template>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Hold Reasons</a>
            <ng-template ngbNavContent>
                <app-fab-hold-reasons-list
                    [canEdit]="canEdit"
                    [items]="holdReasons"
                    (modified)="onChildModified()"
                ></app-fab-hold-reasons-list>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>
